<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <PendingApprovalDesktop v-if="windowResize.width > 650"/>
      <PendingApprovalMobile v-else-if="windowResize.width  > 640" />
    <RotateScreen v-else/>
  </div>
</template>

<script>
import PendingApprovalDesktop from '../components/pending/PendingApprovalDesktop'
import PendingApprovalMobile from '../components/pending/PendingApprovalMobile'
import { useWindowResize } from '@sichern/ui-elements'
import RotateScreen from './RotateScreen'
import { state, mutations } from '../components/Observables/pending'

export default {
  provide: { state, mutations },
  components: {
    PendingApprovalDesktop,
    PendingApprovalMobile,
    RotateScreen
  },
  data() {
    return {
      windowResize: useWindowResize(this)
    }
  },
  computed: {
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid()
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss" scoped>
/* =========================================
   ESTILOS ESPECÍFICOS PARA MODO IFRAME
   ========================================= */
.iframe-mode {
  /* Variables CSS locales para iframe */
  --primary-color: #2694fc;
  --branding-primary: #2694fc;
  --v-primary-base: #2694fc;
  --branding-titleColor: #2694fc;
  
  /* Override de clases de texto primario */
  ::v-deep .text-zt-primary-200,
  ::v-deep .text-zt-primary-100,
  ::v-deep .text-zt-primary-600 {
    color: #2694fc !important;
  }
  
  /* Override de fondos primarios */
  ::v-deep .bg-zt-primary-200 {
    background-color: #2694fc !important;
  }
  
  /* Asegurar que los textos e iconos dentro de botones con fondo primario permanezcan blancos */
  ::v-deep .bg-zt-primary-200.zt-button,
  ::v-deep .zt-button.bg-zt-primary-200 {
    background-color: #2694fc !important;
    
    /* Mantener texto e iconos blancos dentro del botón */
    color: white !important;
    
    .zt-icon,
    i,
    span {
      color: white !important;
    }
  }
  
  /* Override para el spinner de carga */
  ::v-deep .vue-loading .vl-icon {
    svg path {
      fill: #2694fc !important;
    }
  }
  
  /* Override para checkboxes */
  ::v-deep .v-input--selection-controls.v-input--checkbox {
    .v-input--selection-controls__input {
      .v-icon {
        color: #2694fc !important;
      }
    }
    
    &.accent--text {
      color: #2694fc !important;
    }
  }
  
  /* Override para hover de iconos (excepto dentro de botones) */
  ::v-deep .zt-icon:hover:not(.zt-button .zt-icon) {
    color: #2694fc !important;
  }
}

/* Clase helper para texto primario en iframe */
.text-iframe-primary {
  color: #2694fc !important;
}
</style>